(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getfreon-blog-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFilter = (root) => {
      if (root.dataset.blogFilterInitialized === 'true') return;
      root.dataset.blogFilterInitialized = 'true';

      const buttons = [...root.querySelectorAll('[data-blog-filter]')];
      const cards = [...root.querySelectorAll('[data-blog-card]')];
      const loadMore = root.querySelector('[data-blog-load-more]');
      const empty = root.querySelector('[data-blog-filter-empty]');
      const pageSize = Number.parseInt(root.dataset.pageSize, 10) || 12;
      let selectedTag = 'all';
      let visibleLimit = pageSize;

      const matchesTag = (card) => selectedTag === 'all' || card.dataset.tags.split('|').includes(selectedTag);

      const update = () => {
        const matchingCards = cards.filter(matchesTag);
        cards.forEach((card) => {
          const matchingIndex = matchingCards.indexOf(card);
          card.hidden = matchingIndex === -1 || matchingIndex >= visibleLimit;
        });

        empty.hidden = matchingCards.length !== 0;
        if (loadMore) loadMore.hidden = visibleLimit >= matchingCards.length;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedTag = button.dataset.blogFilter;
          visibleLimit = pageSize;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          update();
        });
      });

      loadMore?.addEventListener('click', () => {
        visibleLimit += pageSize;
        update();
      });

      update();
    };

    const initAllFilters = (scope = document) => scope.querySelectorAll('[data-blog-filter-section]').forEach(initFilter);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllFilters(), { once: true });
    else initAllFilters();
    document.addEventListener('shopify:section:load', (event) => initAllFilters(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getfreon-blog-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSearch = (root) => {
      if (root.dataset.blogSearchInitialized === 'true') return;
      root.dataset.blogSearchInitialized = 'true';

      const input = root.querySelector('[data-blog-search-input]');
      const results = root.querySelector('[data-blog-search-results]');
      const status = root.querySelector('[data-blog-search-status]');
      const form = root.querySelector('form');
      const endpoint = root.dataset.searchEndpoint;
      let timer;
      let controller;

      const closeResults = () => {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const renderResults = (articles, query) => {
        results.replaceChildren();

        if (articles.length === 0) {
          const empty = document.createElement('p');
          empty.className = 'gf-blog-hero__search-empty';
          empty.textContent = `No articles found for “${query}”.`;
          results.appendChild(empty);
          status.textContent = `No articles found for ${query}.`;
        } else {
          articles.forEach((article) => {
            const link = document.createElement('a');
            link.className = 'gf-blog-hero__search-result';
            link.href = article.url;
            link.setAttribute('role', 'option');

            const title = document.createElement('span');
            title.textContent = article.title;
            const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            arrow.setAttribute('viewBox', '0 0 24 24');
            arrow.setAttribute('aria-hidden', 'true');
            arrow.innerHTML = '<path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>';
            link.append(title, arrow);
            results.appendChild(link);
          });
          status.textContent = `${articles.length} article${articles.length === 1 ? '' : 's'} found.`;
        }

        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const search = async () => {
        const query = input.value.trim();
        if (query.length < 2) {
          closeResults();
          status.textContent = '';
          return;
        }

        controller?.abort();
        controller = new AbortController();

        try {
          const url = `${endpoint}?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=6&resources[options][fields]=title`;
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search request failed');
          const data = await response.json();
          renderResults(data.resources?.results?.articles || [], query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.replaceChildren();
          const empty = document.createElement('p');
          empty.className = 'gf-blog-hero__search-empty';
          empty.textContent = 'Search is temporarily unavailable. Please try again.';
          results.appendChild(empty);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          status.textContent = 'Search is temporarily unavailable.';
        }
      };

      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(search, 250);
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearTimeout(timer);
        search();
      });
      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closeResults();
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeResults();
      });
    };

    const initAllSearch = (scope = document) => scope.querySelectorAll('[data-blog-article-search]').forEach(initSearch);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllSearch(), { once: true });
    else initAllSearch();
    document.addEventListener('shopify:section:load', (event) => initAllSearch(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hvac-social-proof-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-hvac-social-proof]';

    const init = (root) => {
      if (root.dataset.hspInitialized === 'true') return;

      const track = root.querySelector('[data-hsp-track]');
      const slides = [...root.querySelectorAll('[data-hsp-slide]')];
      const previous = root.querySelector('[data-hsp-previous]');
      const next = root.querySelector('[data-hsp-next]');
      const dots = root.querySelector('[data-hsp-dots]');

      if (!track || slides.length === 0) return;
      root.dataset.hspInitialized = 'true';

      let currentPage = 0;
      let pageCount = 1;
      let scrollFrame;

      const cardsPerPage = () => {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return Math.max(1, Math.round((track.clientWidth + gap) / (slideWidth + gap)));
      };

      const pageOffsets = () => {
        const perPage = cardsPerPage();
        return Array.from({ length: Math.ceil(slides.length / perPage) }, (_, page) => {
          const target = slides[Math.min(page * perPage, slides.length - 1)];
          return target.offsetLeft - track.offsetLeft;
        });
      };

      const updateControls = () => {
        if (dots) {
          [...dots.children].forEach((dot, index) => {
            dot.setAttribute('aria-current', String(index === currentPage));
          });
        }

        if (previous) previous.disabled = currentPage === 0;
        if (next) next.disabled = currentPage === pageCount - 1;
      };

      const goToPage = (page, behavior = 'smooth') => {
        const offsets = pageOffsets();
        pageCount = offsets.length;
        currentPage = Math.max(0, Math.min(page, pageCount - 1));
        track.scrollTo({ left: offsets[currentPage], behavior });
        updateControls();
      };

      const buildDots = () => {
        pageCount = Math.ceil(slides.length / cardsPerPage());
        currentPage = Math.min(currentPage, pageCount - 1);

        if (dots) {
          dots.replaceChildren();
          for (let index = 0; index < pageCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'hvac-social-proof__dot';
            dot.setAttribute('aria-label', `Go to photo page ${index + 1} of ${pageCount}`);
            dot.addEventListener('click', () => goToPage(index));
            dots.appendChild(dot);
          }
        }

        goToPage(currentPage, 'auto');
      };

      previous?.addEventListener('click', () => goToPage(currentPage - 1));
      next?.addEventListener('click', () => goToPage(currentPage + 1));

      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const offsets = pageOffsets();
          currentPage = offsets.reduce((closest, offset, index) => (
            Math.abs(offset - track.scrollLeft) < Math.abs(offsets[closest] - track.scrollLeft) ? index : closest
          ), 0);
          updateControls();
        });
      }, { passive: true });

      new ResizeObserver(buildDots).observe(root);
      buildDots();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
